import { apiClient } from '@/libs/apiClient';
import { ConfigStore } from './config.type';
import { create } from 'zustand';

export const useConfigStore = create<ConfigStore>(set => ({
  websocket_url: null,
  simple_ui: '',
  feature_config: {},
  is_config_loaded: false,
  jarvis_id: null,
  setWebsocketUrl: (url: string | null) => {
    set({ websocket_url: url });
  },
  getConfig: async () => {
    const response = await apiClient.get(`/config`);
    const config = response.data.config;
    set({
      ...config,
    });
    set({ is_config_loaded: true });
  },
  is_help_popup_open: false,
  setIsHelpPopupOpen: (isOpen: boolean) => {
    set({ is_help_popup_open: isOpen });
  },
  openConfig: {},
  is_open_config_loaded: false,
  getOpenConfig: async () => {
    const response = await apiClient.get(`/config/open`);
    const config = response.data.config;
    set({ openConfig: config, is_open_config_loaded: true });
  },
}));

export const useSimpleUi = () => {
  const { simple_ui = '' } = useConfigStore();
  return simple_ui.toLocaleLowerCase() === 'true';
};

export const useFeatureConfig = () => {
  const { feature_config = {}, is_config_loaded } = useConfigStore();
  return { feature_config, is_config_loaded };
};

export const useIsConfigLoaded = () => {
  const { is_config_loaded } = useConfigStore();
  return is_config_loaded;
};
